<template>
  <div class="report">
    <h1>You can report an abuse here</h1>
  </div>
</template>

<script>
export default {
  name: 'report'
}
</script>